module.exports = __webpack_public_path__ + "img/bg_empty.76cf3cb3.png";